import { render, staticRenderFns } from "./systembar.vue?vue&type=template&id=13e5133e&scoped=true&"
import script from "./systembar.vue?vue&type=script&lang=js&"
export * from "./systembar.vue?vue&type=script&lang=js&"
import style0 from "./systembar.vue?vue&type=style&index=0&id=13e5133e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5133e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSystemBar } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VSystemBar})
